/* @ngInject */
const maneuverMenu = (
  $state,
  labels,
  routes
) => {
  const self = {}

  self.radio = {
    value: 'park',
  }

  self.items = {
    park: {
      ref: 'parkMenu',
      label: labels.maneuver.park,
      go: () => {
        const paths = $state.getCurrentPath()
        const path = paths[paths.length - 1]
        const stateName = path.state.name
        if (!stateName.match('maneuver.park')) {
          $state.go(routes.maneuver.park.index.path)
        }
      },
    },
    move: {
      ref: 'moveMenu',
      label: labels.maneuver.move,
      go: () => {
        const paths = $state.getCurrentPath()
        const path = paths[paths.length - 1]
        const stateName = path.state.name
        if (!stateName.match('maneuver.move')) {
          $state.go(routes.maneuver.move.index.path)
        }
      },
    },
    unpark: {
      ref: 'unparkMenu',
      label: labels.maneuver.unpark,
      go: () => {
        const paths = $state.getCurrentPath()
        const path = paths[paths.length - 1]
        const stateName = path.state.name
        if (!stateName.match('maneuver.unpark')) {
          $state.go(routes.maneuver.unpark.index.path)
        }
      },
    },
    scrap: {
      ref: 'scrapMenu',
      label: labels.maneuver.scrap,
      go: () => {
        const paths = $state.getCurrentPath()
        const path = paths[paths.length - 1]
        const stateName = path.state.name
        if (!stateName.match('maneuver.scrap')) {
          $state.go(routes.maneuver.scrap.index.path)
        }
      },
    },
    announce: {
      ref: 'announceMenu',
      label: labels.maneuver.announce,
      go: () => {
        const paths = $state.getCurrentPath()
        const path = paths[paths.length - 1]
        const stateName = path.state.name
        if (!stateName.match('maneuver.announce')) {
          $state.go(routes.maneuver.announce.index.path)
        }
      },
    },
  }

  return self
}

export default maneuverMenu



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/maneuver.menu.js